export interface BasePaginateRes {
    current_page?: number,
    first_page_url?: string,
    from?: number,
    last_page?: number,
    last_page_url?: string,
    links?: any[],
    next_page_url?: string,
    path?: string,
    per_page?: number,
    prev_page_url?: null,
    to?: number,
    total?: number,
}

export interface GlobalAgTableColumns {
    headerName?: string,
    valueGetter?: string,
    cellRenderer?: string,
    cellClass?: string,
    cellRendererParams?: any,
    filter?: boolean,
    width?: number,
}


export const SaudiArabiaFullNumberRegex = /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
export const SaudiArabiaNumberWithoutCountryCodeRegex = /^(\+65|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/;
export const EmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const Website = '^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$';

export enum ControlsTypes {
    text = 'text',
    number = 'number',
    email = 'email',
    password = 'password',
    textarea = 'textarea',
    select = 'select',
    radio = 'radio',
    checkbox = 'checkbox',
    date = 'date',
    time = 'time',
    file = 'file',
    image = 'image',
}

export const AllowedUploadedFile = ['png', 'jpg', 'apng'
    , 'avif', 'gif', 'jpeg', 'pjpeg', 'webp', 'svg', 'xlsx', 'zip', 'rar', 'doc', 'docx', 'wav', 'mp3', 'mp4']


const MessagesTypes = "text" || 'file' || 'ptt' || "link" || 'contact' || 'location' || "vcard" || 'forward'

export interface NumberItem {
    account_id?: 15,
    created_at?: string,
    expired_at?: string,
    id?: number,
    instance_id?: number,
    is_default?: 0,
    me?: any[],
    owner_name?: string,
    status?: string,
    updated_at?: string,
    webhook?: any,
    whatsapp_number_account_package_count?: any,
}

export enum BanksPayment {
    bankRajhi = 1,
    bankAlAhli = 2,
    bankAlRiad = 3,
    bankAlEnmaa = 4,
}

export const Banks = [
    {
        title: "مصرف الراجحي",
        id: "1",
    },
    {
        title: "البنك الاهلي السعودي",
        id: "2",
    },
    {
        title: "بنك الرياض",
        id: "3",
    },
    {
        title: "مصرف الإنماء",
        id: "4",
    },
];

export enum PaymentMethodIds {
    Stripe = 2,
    payoneer = 3,
    Knet = 4,
    fromBalance = 1,
    bankTransfer = 5,
}

export enum HttpErrorResponseStatus {
    unauthorized = 401, // token expired
    forbidden = 403, // not allowed
    notFound = 404, // not found
    internalServerError = 500, // server error
    badRequest = 400, // validation
    conflict = 409, // validation
    unprocessableEntity = 422, // validation
    tooManyRequests = 429, // validation
    serviceUnavailable = 503, // validation
}

export interface createNumber {
    item?: NumberItem
}
export interface SpoolParams {
    sent_status?: 'send' | 'receive' | null,
    whatsapp_number_id?: any,
    export?: 'xlsx' | 'csv' | 'xls' | 'tsv' | 'ods' | 'html' | 'pdf' | null,
    created_at_from?: any,
    created_at_to?: any,
    page?: any,
    total_from?: 0 | 1 | null,
    queued_count_from?: any,
    failed_count_from?: any,
    in_queued_count_from?: any,
    ready_count_from?: any,
    no_package_count_from?: any,
    service_sent_count_from?: any,
    sent_count_from?: any,
    delivered_count_from?: any,
    viewed_count_from?: any,
    read_count_from?: any,
    queue_percentage_from?: any,
    total_to?: any,
    queued_count_to?: any,
    failed_count_to?: any,
    in_queued_count_to?: any,
    ready_count_to?: any,
    no_package_count_to?: any,
    text?: any,
    service_sent_count_to?: any,
    sent_count_to?: any,
    delivered_count_to?: any,
    viewed_count_to?: any,
    read_count_to?: any,
    queue_percentage_to?: any,
    is_working?: any,
    total?: any,
    total_op?: any,
    queued_count?: any,
    take?: any,
    queued_count_op?: any,
    failed_count?: any,
    failed_count_op?: any,
    in_queued_count?: any,
    in_queued_count_op?: any,
    ready_count?: any,
    ready_count_op?: any,
    no_package_count?: any,
    no_package_count_op?: any,
    service_sent_count?: any,
    service_sent_count_op?: any,
    sent_count?: any,
    sent_count_op?: any,
    delivered_count?: any,
    delivered_count_op?: any,
    viewed_count?: any,
    viewed_count_op?: any,
    read_count?: any,
    read_count_op?: any,
    queue_percentage?: any,
    queue_percentage_op?: 'eq' | 'gt' | 'gte' | 'lt' | 'lte' | 'neq' | null,
}

export interface NumbersList {
    item: BasePaginateRes & {
        data: NumberItem[]
    }
}
export interface GalleryList {
    items: BasePaginateRes & {
        data: any[]
    }
}

export interface WhatsAppGateParams {
    path?: string,
    method?: string,
    params?: {
        phone?: number,
        body?: string
    }
}
export interface WhatsAppSendMessageBody {
    messages: [
        {
            data: {
                body: any,
                title?: string
                contactId?: any
                lat?: string
                lng?: string
                caption?: string
                address?: string
                filename?: string
                audio?: string
            },
            numbers: string[]
        }
    ],
    globals: {
        type: typeof MessagesTypes,
        number_iso: string,
        time_frame: any,
    }
}

export interface GlobalAgTableColumns {
    headerName?: string,
    valueGetter?: string,
    cellRenderer?: string,
    cellClass?: string,
    cellRendererParams?: any,
    filter?: boolean,
    width?: number,
}

export enum GlobalErrorCodes {
    ipNotValid = '3003',
    setMobileCode = '3001',
    setEmailCode = '3002',
    AcceptAgreement = '3004',
    setMobileCodeSubAccount = '3005',
    userNotFound = '3006',
    SubUerChangePassword = '3007',
}

export enum QueryParamKeys {
    // Sms
    SmsArchiveUserId = 'user_id',
    SmsArchiveUserName = 'user_name',
    // General
}

//  Routing Paths Data
export enum RoutingData {
    // SMS
    NeedConfirm = "needConfirm",
  }

export enum TableActions {
    edit = 'edit',
    changeStatus = 'CHANGE_STATUS',
    delete = 'delete',
    stop = 'stop',
    add = 'add',
    isDefault = 'isDefault',
    show = 'visibility',
    download = 'download',
    resendCode = 'resend_code',
    more = 'more',
    Check = 'check',
    printContract = 'print',
    contractInvoices = 'wallpaper',
    uploadModel = 'cloud_upload',
    cancelSubscription = 'cancel-subscription',
    salePackage = 'sale-package',
    paymentMethodPermission = 'perm_contact_calendar',
    accountGuidePermission = 'accessibility',
    approve = 'approve',
    refuse = 'refuse',
    refuseReason = 'refuseReason',
    floors = 'floors',
    checked = 'checked',
    connectToDevice = 'connect-finder-device'
}

export enum MessageTypes {
    wanning = 'wanning',
    success = 'success',
    error = 'error',
    noData = 'noData',
    info = 'info',
}

export const AllowedUploadedFileTicket = ['png', 'jpg', 'apng', 'pdf'
    , 'avif', 'gif', 'jpeg', 'pjpeg', 'webp', 'svg', 'xlsx', 'zip', 'rar', 'doc', 'docx', 'wav', 'mp3', 'mp4']

export const AllowedUploadedFileDepositReceipt = ['png', 'jpg', 'apng', 'pdf'
    , 'gif', 'jpeg', 'pjpeg', 'webp', 'svg', 'xlsx', 'zip', 'rar', 'doc', 'docx']

export const MY_FORMATS = {
    parse: {
        dateInput: "DD/MM/YYYY"
    },
    display: {
        dateInput: "DD/MM/YYYY",
        monthYearLabel: "MMM YYYY",
        dateA11yLabel: "DD/MM/YYYY",
        monthYearA11yLabel: "MMMM YYYY"
    }
};

export interface senderFilters {
    customer_type?: any,
    status?: any,
    client_name?: any,
    client_id?: any,
    account_id?: any,
    cr_number?: any,
    enterprise_unified_number?: any,
    representative_email?: any,
    representative_mobile?: any,
    representative_name?: any,
    hawsabah_status?: any,
    is_already_exist?: any,
    sender?: any,
    sent_to_site?: any,
    sent_to_zajel?: any,
    page?: any,
    request_status?: any,
    take?: any,
    sender_key?: any,
    exclude_pending_pays?: any,
    view: 'sender'
}

export const authority = true;

export enum sitePermissions {
    showUsers = 421,
}
export enum ApproveTicketVia {
    APPROVE_BY_FILE = 1,
    APPROVE_BY_DAFTRA = 2,
}

export enum AgGridRowColors {
    danger = 2,
    success = 20,
    green = 50,
}

export enum SalesUserBalanceFilterTypes {
    Balance0 = 'balance0',
    BalanceChargeLast30 = 'balanceChargeLast30',
    BalanceFinishedWithed30 = 'balanceFinishedWithed30',
}

export enum ContractStatus {
    pending = '0',
    pendingApproved = '1',
    approved = '2',
    refused = '3',
    payed = '4',
    expired = '5',
    STATUS_NOTIFIED = '8',
    STATUS_CLIENT_SEND = '9'
}

export enum CustomerTypes {
    governorate = 1,
    charity = 2,
    special = 3,
    global = 4,
    individula = 5
}

export enum SendersRequestStatus {
    needPay = 2,
    NeedPayV2 = 7,
    RefusedByHwsabah = 3
}